(function () {
  angular.module("akitabox.mobile.directives.textCard", [
    "ngSanitize",
    "ngMaterial",
    "akitabox.core",
    "akitabox.core.toast",
    "akitabox.core.utils",
  ]);
})();
